

// document.getElementById('buy_now').addEventListener('click', function() {
//     addToCart(2); // Call your function here
// });



function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function checkDropdownValue(){
    const dropdowns = document.querySelectorAll('.select__select');
    let allValid = true;   

    dropdowns.forEach((dropdown) => {
        if (!dropdown.value || dropdown.value === "--SELECT--"){
            allValid = false;
            dropdown.classList.add('invalid');
        } else {
            dropdown.classList.remove('invalid');
        }
    });

    return allValid;
}


function stylePremiumOptions() {
    const select = document.querySelectorAll('.premium-option-dropdown'); // Get the select element
    // Loop through all options
    for (let i = 0; i < select.length; i++) {
        const option = select[i];
        const match = option.text.match(/\*(.*?)\*/);

        if (match) {
            const cleanText = option.text.replace(/\*(.*?)\*/g, "").trim(); // Remove text between * and *
            const premiumText = match[1]; // Extract the text between * and *
            option.innerHTML = `${cleanText} <span style="color: #800020; font-weight: bold;">${premiumText}</span>`;
        }
    }
}

// Call the function
stylePremiumOptions();

async function addToCart(value){

    let checkDropdown = checkDropdownValue()

    if(!checkDropdown){
        handleCustomAlert("Select All Required Items..")
        return
    }

    if(value == 1){
        document.getElementById('addToCart').disabled = true
        document.getElementById('addtoCartLoader').style.display = "block"
    }

    var splittedProduct = []
    let fragrance = document.getElementById("fragranceName").value
    let product = document.getElementById("selectedProductVariant").value
    let productName = document.getElementById("productName").value
    let productWeight = document.getElementById("selectedProductVariantweight").value
    let productQty = document.getElementById("productIncreasedQty").value
    let totalPrice = document.getElementById("productTotalPrice").value
    let productImageUrl = document.getElementById("productImageUrl").value
    let productDescription = document.getElementById("textarea_description")?.value
    let fileObject = document.getElementById("imageUpload")?.files[0]
    let imageUrl

    if(fileObject){
        function generateUUID() {
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }


        const base64 = await convertFileToBase64(fileObject);
            const payload = {
                blobUrls: [
                {
                    imageURL: await base64,
                    uuid: `${productName}_${generateUUID()}`,
                    id: productName,
                    productType: "customized_sample",
                    sideUiName: "logo"
                }
                ]
            };

            try {
                const response = await fetch("https://d209shvctxmzke.cloudfront.net/api/logo/image/data", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();
                imageUrl = result.data[0].imageURL; // Assuming the API returns the image URL in this format
            } catch (error) {
                console.error("Upload failed:", error);
            }
        
        function convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result); // result includes base64 prefix
                reader.onerror = reject;
                reader.readAsDataURL(file); // reads file as base64 data URL
            });
        }
    }
   
    if(product && product.includes("/")){
        splittedProduct = product.split('/')
    }
    else{
        splittedProduct.push(product)
    }
    let properties = {}
    let checkoutBtn =  document.getElementById("buy_now")
    
    properties["_screenshot"] = productImageUrl    

    
    if(fragrance === "" && totalPrice === ""){
        handleCustomAlert("Select All Required Items..")
        return
    }
    else{

        if(product != "Default Title"){

            var valuesArray = [];

            let productOptionsName = document.getElementsByClassName("product-options-name")

            for (let i = 0; i < productOptionsName.length; i++) {
                valuesArray.push(productOptionsName[i].value);
            }

            for (let i = 0; i < valuesArray.length; i++) {
                let key = valuesArray[i];  // Use textContent if not an input field
                // properties[key] = splittedProduct.map((segment, index) => segment);
                if (i < splittedProduct.length) {
                    properties[key] = splittedProduct[i];
                } else {
                    properties[key] = ''; // Assign an empty string if there are not enough elements
                }
            }

            properties["FRAGRANCE"] = fragrance


            // properties = {
            //     "FRAGRANCE": fragrance,
            //     "JAR COLOR": splittedProduct[0], 
            //     "BOTTOM WARNING LABEL": splittedProduct[1],
            // }
    
        } else if(fragrance) {
            properties = {
                "FRAGRANCE": fragrance,
            }
    
        }

        if(imageUrl){
            properties["CUSTOM LOGO"] = imageUrl
        }

        if(productDescription){
            properties["CUSTOM DESCRIPTION"] = productDescription
        }


    
        postData = {
            "product_name":productName,
            "image_url":`https:${productImageUrl}`,
            "total_price":totalPrice,
            "weight":productWeight,
            "type":"unlabelled"
        }
    
        const apiUrl = 'https://usysbr4ocwednzd4ovetglfxiu0uibbt.lambda-url.us-east-2.on.aws/';
    
        // Fetch data from the API
        await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData),
        })
        .then(response => response.json())
        .then(data => {
            ProductsData = {
                "id":data.variant_id,
                "quantity":productQty,
                "properties":properties
            }
            setCookie('addedProductCart', 'true', 7);
            fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(ProductsData),
              }).then((response) => {
                if (response.status == 200) {
                    if(value == 1){
                        document.getElementById('addtoCartLoader').style.display = "none"
                        handleCustomCartAlert()
                    } else{
                        // document.getElementById('buyNowLoader').style.display = "none"
                        window.location.href = "/checkout"
                    }
                }
            })
            
        })
        .catch((error) => {
            console.error('Error:', error);
        });

    }
}

function toggleDropdown(dropdown) {
    const options = dropdown.querySelector('.custom-dropdown__options');
  
    // Toggle the dropdown visibility
    options.classList.toggle('show');
  }
  
  function selectOption(option) {
    const dropdown = option.closest('.custom-dropdown');
    const selected = dropdown.querySelector('.custom-dropdown__selected');
    const options = dropdown.querySelector('.custom-dropdown__options');
  
    const value = option.getAttribute('data-value');
    const price = option.getAttribute('data-price');
    const title = option.getAttribute('data-title');
  
    selected.innerHTML = option.innerHTML;
    selected.setAttribute('data-value', value);
    selected.setAttribute('data-price', price);
    selected.setAttribute('data-title', title); 
  
    // Hide the dropdown after selection
    options.classList.remove('show');
  
    // Call addFragrance function (ensure it's defined somewhere)
    addFragrance(value, selected);
  
    // Stop event from bubbling
    event.stopPropagation();
  }
  
  // Close dropdown if clicked outside
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.custom-dropdown__options').forEach((options) => {
      const dropdown = options.closest('.custom-dropdown');
      if (!dropdown.contains(event.target)) {
        options.classList.remove('show');
      }
    });
  });

function cartBtnUpdate(){
    let addToCartBtn =  document.getElementById("addToCart")

    addToCartBtn.replaceWith(addToCartBtn.cloneNode(true));
}

cartBtnUpdate()

document.getElementById('addToCart').addEventListener('click', function() {
    addToCart(1);
});
